import 'bootstrap/dist/js/bootstrap.js';
import './i18n';
import './styles.scss';

import * as Sentry from '@sentry/react';

import React, { Suspense } from 'react';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { EnvironmentEnum } from './enums';
import ReactDOM from 'react-dom';
import { Spinner } from './utils';

if (EnvironmentEnum.DEVELOPMENT !== process.env.REACT_APP_ENV && EnvironmentEnum.REVIEW_APP !== process.env.REACT_APP_ENV) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay({
        blockAllMedia: false,
        maskAllText: false,
      }),
    ],
    release: `sce@${process.env.REACT_APP_VERSION}`,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
